/***********************************************
* LandingPage.js
* 
* Show a landingpage
***********************************************/
/* Layout files */
import '../assets/style/LandingPage.css';

/* Global imports */
import React   from 'react';
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Markdown from 'markdown-to-jsx'
import { getAppUrl } from '../App';

/* Allow this component to navigate to different pages */
function withRouter(Component) {
    function ComponentWithRouterProp(props) {
        let location = useLocation();
        let navigate = useNavigate();
        let params = useParams();
        return (<Component {...props} router={{ location, navigate, params }} />);
    }
  
    return ComponentWithRouterProp;
}

class ExamplePage extends React.Component {
    constructor(props) {
        super(props);
        this.state = { markdown: '' };
        
        /* Get the markdown page in the correct language */
        fetch(window.location.origin + '/docs/ExamplePage/' + props.language.active + '.md').then(res => res.text()).then(text => this.setState({ markdown: text }));
    }

    componentDidUpdate(prevProps) {
        /* If the language changes */
        if (prevProps.language !== this.props.language) {
            /* Get the new markdown page in the correct language */
            fetch(window.location.origin + '/docs/ExamplePage/' + this.props.language.active + '.md').then(res => res.text()).then(text => this.setState({ markdown: text }));
        }
    }

    render() {
        const navigate = this.props.router.navigate;
        const { markdown } = this.state;

        return (
            <div className="fullMarkdownPage">
                <div className="loginMarkdownDiv">
                    <select name="language" id="language" className="languageSelect" value={this.props.language.active} onChange={(e) => this.props.language.set(e.target.value)}>
                        {this.props.language.list.map((lang) => <option key={lang} value={lang}>{lang}</option>)}
                    </select>
                    <a href={getAppUrl()} className="button bigButton">Login</a>
                </div>
                <div className='contentExamplePage contentPage'>
                    <Markdown>{markdown}</Markdown>
                </div>
            </div>
        );
    }
}

export default withRouter(ExamplePage);